import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';

const initialData = {
  newToken: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'refreshToken',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchRefreshToken: (state, action) => {
      state.newToken = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      // state.successMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetSuccess: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchRefreshToken, fetchStart, resetSuccess, fetchError} = slice.actions;

export const fetchToken = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`user/refreshtoken`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchRefreshToken(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const SuccessMsg = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};
